import * as yup from 'yup';

/*
 * yup doesn't appear to have any way to map a schema to `null` so we have
 * to manually cast it here for proper TypeScript intellisense.
 */
export const NullResponseSchema = yup
  .mixed()
  .nullable()
  .defined()
  .test(val => val === null) as yup.MixedSchema<
  null,
  yup.AnyObject,
  undefined,
  ''
>;

export type NullResponse = yup.InferType<typeof NullResponseSchema>;
